import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from '../context/ThemeContext';

/**
 * Sun/Moon toggle button. Hidden if empresa.tema.allow_user_toggle === false.
 */
export default function ThemeToggle({ className = '', size = 'icon', ...props }) {
    const { mode, toggleMode, allowUserToggle } = useTheme();

    if (!allowUserToggle) return null;

    return (
        <Button
            variant="ghost"
            size={size}
            onClick={toggleMode}
            className={className}
            data-testid="theme-toggle"
            title={mode === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
            {...props}
        >
            {mode === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </Button>
    );
}
